import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prov-dashboard',
  templateUrl: './prov-dashboard.component.html'
})
export class ProvDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers-external/prov-dashboard/prov-dashboard.component.ts